"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _focus = require("@react-aria/focus");

var _checkbox = require("@react-aria/checkbox");

var _toggle = require("@react-stately/toggle");

var _visuallyHidden = require("@react-aria/visually-hidden");

var _v = _interopRequireDefault(require("uuid/v4"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Checkbox = function CheckboxComponent(props) {
  var className = props.className,
      describedBy = props.describedBy,
      focusRingClass = props.focusRingClass,
      labelledBy = props.labelledBy,
      children = props.children,
      required = props.required,
      labelRef = props.labelRef;
  var labelId = (0, _react.useRef)((0, _v["default"])());
  var state = (0, _toggle.useToggleState)(props);
  var ref = (0, _react.useRef)();

  var _useCheckbox = (0, _checkbox.useCheckbox)(props, state, ref),
      inputProps = _useCheckbox.inputProps;

  var _useFocusRing = (0, _focus.useFocusRing)(),
      isFocusVisible = _useFocusRing.isFocusVisible,
      focusProps = _useFocusRing.focusProps;

  var focusClass = focusRingClass || 'checkbox__focus-ring';
  var labelProps = {
    className: (0, _classnames["default"])(className, _defineProperty({
      'checkbox__label--checked': state.isSelected
    }, focusClass, isFocusVisible)),
    ref: labelRef
  };
  var iconClassNames = (0, _classnames["default"])('checkbox__icon', {
    'checkbox__icon--checked': state.isSelected
  });
  inputProps['aria-labelledby'] = (0, _classnames["default"])(labelId.current, labelledBy);
  inputProps['aria-describedby'] = describedBy;
  inputProps['aria-checked'] = null;
  return /*#__PURE__*/_react["default"].createElement("label", labelProps, /*#__PURE__*/_react["default"].createElement(_visuallyHidden.VisuallyHidden, {
    elementType: "span"
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, inputProps, focusProps, {
    ref: ref,
    required: required
  }))), /*#__PURE__*/_react["default"].createElement("span", {
    className: iconClassNames
  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: labelId.current,
    className: "checkbox__label"
  }, children));
};

Checkbox.propTypes = {
  className: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]).isRequired,
  describedBy: _propTypes["default"].string,
  focusRingClass: _propTypes["default"].string,
  labelledBy: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  labelRef: _propTypes["default"].shape({})
};
Checkbox.defaultProps = {
  describedBy: '',
  labelledBy: '',
  focusRingClass: '',
  required: false,
  labelRef: null
};
var _default = Checkbox;
exports["default"] = _default;